import React, { useEffect, useState } from "react"
import {  DateBox, TextArea, TextBox} from 'devextreme-react';
import { useDispatch, useSelector } from "react-redux";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/selectors";
import dayjs from "dayjs";
import { selectContract } from "../../../../../redux/contract/selectors";
function InputWrapper(props){
const {classes, label} = props;
    return(
        <div className="dx-field">
        <label className={classes.label}>{label}</label> 
            <div style={{width:"100%"}} className="dx-field-value">
                {props.children}
            </div>
    </div>
    )
}

function OvcForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const [type, setType] = useState(dataForm?.templateCode)
const contract = useSelector(selectContract);
const [company, setCompany] = useState(contract?.customerName)
useEffect(()=>{
    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))
    onChange("company", company)
    if(types && types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
        setType(types[0].id);
    }
    
},[])

useEffect(()=>{
    if(types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
        setType(types[0].id);
    }
},[types])

function changeDate(field, date){
    let stringDate = null; 
    if(date){
    stringDate = dayjs(date).format()
    }
    onChange(field,stringDate)
}

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

    return(
        <div className={classes.containers} id="documentation-request-form">
                <InputWrapper classes={classes} label={"Fecha y hora"}>
                    <DateBox displayFormat={"dd/MM/yyyy HH:mm"} applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"date"} name="date" type="datetime" value={dataForm?.date} onValueChanged={(e) => changeDate("date", e.value)} className={classes.controlers} height={25}></DateBox>
                </InputWrapper>
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Empresa"}>
                        <TextBox key={"company"} name="company" value={company} onValueChanged={(e) =>{setCompany(e.value); onChange("company",e.value)}} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper> 
                    <InputWrapper classes={classes} label={"DNI/CIF"}>
                        <TextBox key={"dni"} name="dni" value={dataForm?.dni} onValueChanged={(e) => onChange("dni",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>                                       
                </div> 
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Nombre"}>
                        <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Apellidos"}>
                        <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                </div>
                <div className={classes.input_grid} style={{marginBottom: "10px"}}>                           
                    <InputWrapper classes={classes} label={"Móvil"}>
                        <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>   
                    <InputWrapper classes={classes} label={"Correo electrónico"}>
                            <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>                                    
                </div>        
                <InputWrapper classes={classes} label={"Motivo de contacto"}>
                    <TextArea key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
                </InputWrapper>
        </div>
    )
}

export { OvcForm }